// @ts-nocheck
export default {
    SET_BANK_DATA: (state, bank) => {
        state.data = bank;
    },
    SET_VIRTUAL_BANK: (state, virtualBank) => {
        state.virtualBank = virtualBank;
    },
};
